import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  IA_STI_FETCH_SITE_INFO_BEGIN,
  IA_STI_FETCH_SITE_INFO_SUCCESS,
  IA_STI_FETCH_SITE_INFO_FAILURE,
  IA_STI_FETCH_SITE_INFO_DISMISS_ERROR,
} from './constants';

export function fetchSiteInfo(role, sellerId) {
  return (dispatch, getState) => {
    dispatch({
      type: IA_STI_FETCH_SITE_INFO_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      
      const doRequest = axios.get(`${API_REQUEST_URL}/fetchOrgData`, {
        headers: {
          'Authorization': token,
        }
      });
      
      doRequest.then(
        (res) => {
          let filteredData = res.data;
          if (role === 'Corp' && sellerId === 'CABL') {
            filteredData = res.data.filter(item => item.market === 'Canada');
          } else if ((role === 'Corp' || role === 'RCM') && sellerId === 'USBL') {
            filteredData = res.data.filter(item => item.market !== 'Canada');
          }
          const siteMap = new Map();
          if (Array.isArray(filteredData)) {
            filteredData.forEach(market => {
              if (market.regions && Array.isArray(market.regions)) {
                market.regions.forEach(region => {
                  if (region.sites && Array.isArray(region.sites)) {
                    region.sites.forEach(site => {
                      // Use site_nbr as unique key
                      if (site.site_nbr && !siteMap.has(site.site_nbr)) {
                        siteMap.set(site.site_nbr, {
                          site_nbr: site.site_nbr,
                          site_desc: site.site_desc || `Site ${site.site_nbr}`
                        });
                      }
                    });
                  }
                });
              }
            });
          }
          
          // Convert map to array
          const sitesArray = Array.from(siteMap.values());
          
          // Sort sites by description alphabetically
          sitesArray.sort((a, b) => {
          return a.site_desc.localeCompare(b.site_desc);
          });
          dispatch({
            type: IA_STI_FETCH_SITE_INFO_SUCCESS,
            data: sitesArray,
          });
          resolve(sitesArray);
        },
        (err) => {
          console.error('fetchOrgData error:', err);
          const errorMsg = err && err.response 
            ? err.response.data.message 
            : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: IA_STI_FETCH_SITE_INFO_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchSiteInfoError() {
  return {
    type: IA_STI_FETCH_SITE_INFO_DISMISS_ERROR,
  };
}

export function useFetchSiteInfo() {
  const dispatch = useDispatch();

  const { siteList, fetchSiteInfoPending, fetchSiteInfoError } = useSelector(
    state => ({
      siteList: state.iaSTIInquiry.siteList || [],
      fetchSiteInfoPending: state.iaSTIInquiry.fetchSiteInfoPending,
      fetchSiteInfoError: state.iaSTIInquiry.fetchSiteInfoError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchSiteInfo(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchSiteInfoError());
  }, [dispatch]);

  return {
    siteList,
    fetchSiteInfo: boundAction,
    fetchSiteInfoPending,
    fetchSiteInfoError,
    dismissFetchSiteInfoError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case IA_STI_FETCH_SITE_INFO_BEGIN:
      return {
        ...state,
        fetchSiteInfoPending: true,
        fetchSiteInfoError: null,
      };

    case IA_STI_FETCH_SITE_INFO_SUCCESS:
      return {
        ...state,
        siteList: action.data,
        fetchSiteInfoPending: false,
        fetchSiteInfoError: null,
      };

    case IA_STI_FETCH_SITE_INFO_FAILURE:
      return {
        ...state,
        fetchSiteInfoPending: false,
        fetchSiteInfoError: action.data.error,
      };

    case IA_STI_FETCH_SITE_INFO_DISMISS_ERROR:
      return {
        ...state,
        fetchSiteInfoError: null,
      };

    default:
      return state;
  }
}


